"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var get_date_time_parts_1 = require("./get-date-time-parts");

function getTimeZoneOffset(date, timeZone1, timeZone2) {
  if (date === void 0) {
    date = new Date();
  }

  var date1 = constructZonedDateFromParts(date, timeZone1);
  var date2 = constructZonedDateFromParts(date, timeZone2);
  return (date1.valueOf() - date2.valueOf()) / (1000 * 60);
}

exports.getTimeZoneOffset = getTimeZoneOffset;

function constructZonedDateFromParts(date, timeZone) {
  var _a = get_date_time_parts_1.getDateTimeParts(date, timeZone),
      year = _a.year,
      month = _a.month,
      day = _a.day,
      hour = _a.hour,
      minute = _a.minute,
      second = _a.second;

  return new Date(Date.UTC(year(), month() - 1, day(), hour(), minute(), second()));
}